import { render, staticRenderFns } from "./DocumentOnDemand.vue?vue&type=template&id=97a42084&scoped=true&"
import script from "./DocumentOnDemand.vue?vue&type=script&lang=js&"
export * from "./DocumentOnDemand.vue?vue&type=script&lang=js&"
import style0 from "./DocumentOnDemand.vue?vue&type=style&index=0&id=97a42084&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a42084",
  null
  
)

export default component.exports